import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { add as addToCart } from '../Actions/Cart.action';
import { translate } from '../Services/translation';

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = React.createRef();
    }
    

    addToCart(articleNumber, quantityFieldId){       
        this.props.addToCartClick(this.buttonRef.current, articleNumber, quantityFieldId)
    }
    

    render() {
        return (
            <span className='buy-button_container' ref={this.buttonRef}>
                {!this.props.buyButton.hidden && (
                    <BuyButton {...this.props} disabled={this.props.buyButton.disabled}
                        onClick={(articleNumber, quantityFieldId) => this.addToCart(articleNumber, quantityFieldId)} /> 
                )}
            </span>
        );
    }
}

const mapStateToProps = state => {
    return {
        buyButton: state.buyButton
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addToCartClick: (buttonDomNode, articleNumber, quantityFieldId) => {
            const nodeIdToShowNotification = buttonDomNode.id = Date.now();
            const isProductBlock = document.getElementById("product-list-block");

            let quantity = 1;

            if (isProductBlock) {
                quantity = parseFloat(document.getElementById(quantityFieldId).value.replace(",", "."));
            } else {
                let hiddenQuantity = document.getElementById('calculatedquantity')
                quantity = hiddenQuantity ? hiddenQuantity.value : 1
            }

            dispatch(addToCart({ 
                articleNumber, 
                quantity: quantity,
                nodeIdToShowNotification,
                notificationMessage: translate('tooltip.addedtocart'),
                hash: Date.now(),
            }));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyButtonContainer);
